
import { useMq } from "../common/mediaquery";

interface options {
  trigger: string;
  only?: 'sp' | 'pc';
}

export function Accordion(obj: options) {
  class Accordion {
    triggers: NodeListOf<Element>;

    constructor() {
      this.triggers = document.querySelectorAll(`.${obj.trigger}`)
      this.init();
    }

    init() {
      Array.prototype.forEach.call(this.triggers, (trigger) => {
        this.accordion(trigger);
      });
    }

    accordion(trigger) {
      const accordionBtn: HTMLElement = trigger.querySelector(`.${obj.trigger}__button`);
      const accordionContent: HTMLElement = trigger.querySelector(`.${obj.trigger}__content`);
      const accordionContentHeight = accordionContent.scrollHeight;
      // accordionContent.style.maxHeight = accordionContentHeight + 'px';
      accordionBtn.addEventListener('click', (event) => {
        event.preventDefault();
        trigger.classList.toggle('is-opened');
        //is-openedクラスの有無を確認
        if (trigger.classList.contains('is-opened')) {
          accordionContent.style.maxHeight = accordionContentHeight + 'px';
        }else{
          accordionContent.style.maxHeight = null;
        }
      });
    }
  }

  obj.only === 'sp' ? useMq({
    type: 'max',
    query: '767px',
    onMatch: () => {
      new Accordion();
    },
    onUnmatch: () => {
      return;
    }
  }) :

  obj.only === 'pc' ? useMq({
    type: 'min',
    query: '768px',
    onMatch: () => {
      new Accordion();
    },
    onUnmatch: () => {
      return;
    }
  }) :

  new Accordion();
}
